import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { StelaBreadcrumbItem } from '../../models/stela-layout.models';

@Component({
  selector: 'stela-breadcrumbs',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './stela-breadcrumbs.component.html',
  styleUrl: './stela-breadcrumbs.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StelaBreadcrumbsComponent {
  readonly items = input<StelaBreadcrumbItem[]>([]);
}
